import PortalAppService from "../../../application/platform/portal-app-service";
import { useBiddingDetailDispatch } from "./bidding-detail-context";
import { ACTION_TYPES } from "./bidding-detail-reducer";

export const useBiddingDetailController = () => {
    const dispatch = useBiddingDetailDispatch();

    const loadBiddingDetail = async (id: number) => {
        try {
            const biddingDetail = await PortalAppService.getBiddingDetail(id);
            dispatch({ type: ACTION_TYPES.SET_BIDDING_DETAIL, payload: biddingDetail });
        } catch (error) {
            console.error('Error loading bidding detail:', error);
        }
    };

    return { loadBiddingDetail };
};
